<template>
  <div id="app" :style="note">
    <div class="box">
      <div class="previewTitle" v-text="formEstablish.title">后保研夏令营论文试听课报名表</div>
      <div class="previewSubtitle" v-text="formEstablish.subTitle">后保研夏令营论文试听课报名表</div>
      <div id="form-create" ref="formCreate">
      </div>

       <div style="text-align: center;
    font-size: 12px;
    color: rgba(0,0,0,.5);margin: 5px 0;display: flex;align-items: center;justify-content: center">
        表单ID： {{id}}
      </div>
      <div style="text-align: center;
    font-size: 12px;
    color: rgba(0,0,0,.5);margin: 5px 0;display: flex;align-items: center;justify-content: center">
        <img src="../assets/logo2.png" alt="" style="width: 15px;margin-right: 5px;">
        后保研技术中心提供支持
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import extra from "@/component/extra/index.vue"; // 引入组件
import {formPreview,submit} from '@/request/main.js'
import {Notify} from "vant";
export default {
  name: "index",
  data(){
    return{
      id: "",
      access_rule:'',
      options:{},
      formEstablish:{},
      note:{
        backgroundImage: "url(" + 'https://hbyoss.houbaoyan.cn/cms/form/themeImg/formThemeImgDefault.png' + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: 'cover',
      },
    }
  },
  mounted() {
    if(this.$route.query.access_rule){
      this.access_rule = this.$route.query.access_rule;
      this.init();
    }
  },
  methods:{
    init(){
      let data = {
        accessFormId:this.$route.query.access_rule
      }
      formPreview(data).then(res=>{
        this.formEstablish = res.data

        this.id = res.data.id;
        let rule = JSON.parse(res.data.rule);
        this.$set(this.note,'backgroundImage', "url(" + res.data.themeImgUrl + ")")
        document.title = res.data.title
        let root = document.getElementById('form-create');
        let $f = {},model = {};
        let that = this;

        //$f为表单api
        window.formCreate.create([],{
          el:root,})
        this.form = $f = window.formCreate.create(
          //表单生成规则
          rule,
          //组件参数配置
          {
            el:root,
            global:{
              //设置所有组件
              '*':{
                col:{
                  span:24,
                  labelWidth:150
                },
                props:{
                  disabled:false
                }
              }
            },
            form:{
              labelPosition: 'top',
              inline: false,
              size: 'small',
            },
            submitBtn:{
              type: "primary",
              //尺寸 medium / small / mini
              size: "small",
              width: '30%',
            },
            //表单提交事件
            onSubmit:function (formData) {
              let data = {
                accessFormId:that.access_rule,
                customerInfoJsonStr:JSON.stringify(formData),
                extraFileJsonStr:JSON.stringify(that.options.file)
              }
              if(res.data.hasExtraFile==1){
                if(that.options.file.length<1){
                  Notify({type: 'warning', message: '请上传附件'});
                  return
                }
              }

              //按钮进入提交状态
              // $f.btn.loading();
              submit(data).then(res=>{
                that.$router.push({
                  path: '/form/success'
                })
              })

              //formData为表单数据
            }
          });
        //获取双向数据绑定的数据规则
        // model = $f.model();
        if(res.data.hasExtraFile==1){
          this.extraHtml(res.data.extraFileTitle)
        }
      })
    },
    extraHtml(title){
      let extraCon = Vue.extend(extra);
      let instance;
      let that = this;
      const extraB = function (options = {}) {
        instance = new extraCon ({
          data: options
        }).$mount(); // 创建实例
        that.options = options
        console.log(options)
        that.$refs.formCreate.getElementsByClassName('el-form--label-top')[0].getElementsByClassName('el-button')[0].before(instance.$el)
      };

      extraB({
        name:title
      })
    },
  }
}
</script>

<style scoped>
#app{
  width: 100%;
  background: #e1e7eb;
  overflow: hidden;
  min-height: 70vh;
}
.box {
  min-height: 70vh;
  background: rgba(255,255,255,0.6);
  max-width: 730px;
  margin: 0 auto 0;
  position: relative;
  padding: 10px 30px;
}

#form-create{
  padding: 10px 20px;
}
>>> .el-radio{
  width: 100%;
  padding: 5px;
}
>>> .el-checkbox{
  width: 100%;
  padding: 5px;
}
>>> .el-button.el-button--primary.el-button--small{
  margin-left: 35%;
}
.previewTitle{
  text-align: center;
  font-size: 1.4rem;
  color: #413573;
  font-weight: 700;
}
.previewSubtitle{
  text-align: center;
  font-size: 14px;
  color: #525252;
  margin-top: 5px;
}
>>>.el-radio+.el-radio,>>>.el-checkbox+.el-checkbox {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/form/index.vue